import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionButton from '@24i/nxg-sdk-gluons/src/components/buttons/ActionButton';
import { BLOCKING_REASON_TYPES } from '@24i/nxg-sdk-photon';
import { BlockingMessageIcon } from '../../../BlockingMessageIcon';
export const UnlockButton = ({ blockingReason, onUnlockAction, styles = {
    button: null,
    icon: null,
}, }) => {
    const { t } = useTranslation(['sott']);
    const isUnlockable = [BLOCKING_REASON_TYPES.AGE, BLOCKING_REASON_TYPES.ADULT].includes(blockingReason);
    if (!isUnlockable) {
        return React.createElement(BlockingMessageIcon, { blockingReason, onUnlockAction, style: styles === null || styles === void 0 ? void 0 : styles.icon });
    }
    return React.createElement(ActionButton, { title: t('player.unlock'), onPress: onUnlockAction });
};
//# sourceMappingURL=index.js.map